const countIntersection = (sponsoredProductIds, products) => {
  if (!sponsoredProductIds || !products?.length) return 0;

  const whitelist = new Set(sponsoredProductIds.split("|").filter(Boolean));

  return products.filter((product) => whitelist.has(product?.ProductId)).length;
};

export default countIntersection;
